import { Storage } from './enums';
import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';

// Define the type for the context data
interface AppContextType {
  adminToken: string | unknown;
  updateAdminToken: Function;
  logout: Function;
}

// Create the context with default values
const AppContext = createContext<AppContextType | undefined>(undefined);

// Create a provider component
export const AppProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [adminToken, setAdminToken] = useState<string | unknown>(null);

  const updateAdminToken = (token: string) => {
    localStorage.setItem(Storage.ADMIN_TOKEN, token);
    setAdminToken(token);
  };

  const logout = () => {
    localStorage.removeItem(Storage.ADMIN_TOKEN);
    setAdminToken(null);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const token = localStorage.getItem(Storage.ADMIN_TOKEN);
      setAdminToken(token);
    }
  }, []);

  const contextValue: AppContextType = {
    adminToken,
    updateAdminToken,
    logout,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};

// Custom hook to use the context
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
